import { clientInfo } from 'configureBrand'
import { isNotIE } from 'helpers'

const isAndroid = /Android/i.test(window.navigator.userAgent)
export const enabledPlatform =
  isNotIE() && clientInfo.androidApp.id && isAndroid ? 'android' : 'none'

const smartBannerMetaTag = [
  {
    name: 'apple-itunes-app',
    content: `app-id=${clientInfo.iOSAppId}`
  },
  {
    name: 'smartbanner:title',
    content: clientInfo.androidApp.title
  },
  {
    name: 'smartbanner:author',
    content: clientInfo.androidApp.author
  },
  {
    name: 'smartbanner:price',
    content: 'FREE'
  },
  {
    name: 'smartbanner:price-suffix-google',
    content: ' - In Google Play'
  },
  {
    name: 'smartbanner:icon-google',
    content: clientInfo.androidApp.image
  },
  {
    name: 'smartbanner:button',
    content: 'VIEW'
  },
  {
    name: 'smartbanner:button-url-google',
    content: `https://play.google.com/store/apps/details?id=${clientInfo.androidApp.id}`
  },
  {
    name: 'smartbanner:enabled-platforms',
    content: enabledPlatform
  },
  {
    name: 'smartbanner:custom-design-modifier',
    content: 'ios'
  },
  {
    name: 'smartbanner:close-label',
    content: 'Close'
  }
]

export default smartBannerMetaTag
